import type { QueryClient } from "@tanstack/react-query";
import type { NavigateFn } from "@tanstack/react-router";
import { primeGeneratedTextDetailsQuery } from "../hooks/useGeneratedTextDetails";
import type { RabbitHoleDiscovery } from "../hooks/useRabbitHole";
import type { GeneratedText } from "../hooks/types/GeneratedTexts";
import { resolveCanonicalGeneratedTextForRabbitHoleDiscovery } from "./rabbitHoleDiscoveryState";

const openingRabbitHoleDiscoveryIds = new Set<number>();

export async function openRabbitHoleDiscovery(arg: {
  discovery: RabbitHoleDiscovery;
  languageSpace: string;
  generatedTexts: GeneratedText[];
  queryClient: QueryClient;
  navigate: NavigateFn;
  setLanguageSpace: (languageSpace: "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN") => void;
}) {
  if (openingRabbitHoleDiscoveryIds.has(arg.discovery.id)) return;

  openingRabbitHoleDiscoveryIds.add(arg.discovery.id);
  arg.setLanguageSpace(arg.languageSpace as "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN");
  const canonicalDiscoveryText = resolveCanonicalGeneratedTextForRabbitHoleDiscovery({
    discovery: arg.discovery,
    generatedTexts: arg.generatedTexts,
  });
  if (canonicalDiscoveryText) {
    primeGeneratedTextDetailsQuery(arg.queryClient, canonicalDiscoveryText);
  }

  try {
    await arg.navigate({
      to: "/app/reeprise/$generatedTextId",
      params: { generatedTextId: String(arg.discovery.id) },
      search: {
        chapter: undefined,
        focusSentence: undefined,
        focusToken: undefined,
        focusWord: undefined,
        jumpTo: undefined,
      },
    });
  } finally {
    openingRabbitHoleDiscoveryIds.delete(arg.discovery.id);
  }
}
